export class BaseClass {
  View: boolean;
  Edit: boolean;
  Add: boolean;
  constructor(
    obj: { View: boolean; Edit: boolean; Add: boolean } = {
      View: false,
      Edit: false,
      Add: false,
    }
  ) {
    this.View = !!obj.View;
    this.Edit = !!obj.Edit;
    this.Add = !!obj.Add;
  }
}
